import React from 'react'
export var ODLoading = function (props) {
  return React.createElement('div', null, 'Loading...')
}
//# sourceMappingURL=ODLoading.js.map
